/* @flow */
import axios from 'axios';
import config from '../../../constants/Config';
import { getAuthorizationHeader } from '../../../helper-classes/utility-functions';

const FLEETIO_API_URL = config.get('FLEETIO_PARTNER_ADAPTER_API_URL');

export function getFleetioAccount() {
    return axios
        .get(`${FLEETIO_API_URL}/accounts`, {
            headers: {
                Authorization: getAuthorizationHeader(),
            },
        })
        .then(response => response.data)
        .catch((error) => {
            // eslint-disable-next-line no-console
            console.error('Fleetio getAccount failed:', error);
            return null;
        });
}

export function saveFleetioAccount(payload = {}) {
    return axios
        .post(`${FLEETIO_API_URL}/accounts`, payload, {
            headers: {
                Authorization: getAuthorizationHeader(),
            },
        })
        .then(response => response.data);
}

export function updateFleetioAccount(payload = {}) {
    return axios
        .put(`${FLEETIO_API_URL}/accounts`, payload, {
            headers: {
                Authorization: getAuthorizationHeader(),
            },
        })
        .then(response => response.data);
}

export function deleteFleetioAccount() {
    return axios
        .delete(`${FLEETIO_API_URL}/accounts`, {
            headers: {
                Authorization: getAuthorizationHeader(),
            },
        })
        .then(response => response.data);
}

export function getFleetioAssets(offset = 0, limit = 100, sortBy = '', sortOrder = '') {
    const sortParams = sortBy ? `&sortBy=${sortBy}&sortOrder=${sortOrder}` : '';
    return axios
        .get(`${FLEETIO_API_URL}/assets?offset=${offset}&limit=${limit}${sortParams}`, {
            headers: {
                Authorization: getAuthorizationHeader(),
            },
        })
        .then(response => response.data)
        .catch((error) => {
            // eslint-disable-next-line no-console
            console.error('Fleetio getAssets failed:', error);
            return null;
        });
}

export function updateFleetioAssetSyncPreference(assetId, payload = {}) {
    return axios
        .patch(`${FLEETIO_API_URL}/assets/${assetId}`, payload, {
            headers: {
                Authorization: getAuthorizationHeader(),
            },
        })
        .then(response => response.data);
}

export function getFleetioAssetById(assetId) {
    return axios
        .get(`${FLEETIO_API_URL}/assets/${assetId}`, {
            headers: {
                Authorization: getAuthorizationHeader(),
            },
        })
        .then(response => response.data)
        .catch((error) => {
            // eslint-disable-next-line no-console
            console.error('Fleetio getAssetById failed:', error);
            return null;
        });
}
